
// react-bootstrap imports
import { useEffect, useState } from "react"
import { Button, Form } from "react-bootstrap"

import { useNavigate } from "react-router-dom"
import * as Links from "constants/links"

// components imports
import { TextInput } from "components/Inputs"
import { ErrorChamadaApiMessage, SuccessDataSaved, WarningIncompleteInput, WarningInvalidInput } from "components/AlertMessages"

import { userLogado, userHasAccess } from "services/LoginFunctions"
import { AlterarSenhaParaTemporaria } from "services/CallAPIs"
import { getFormData } from "services/FormFunctions"

import stdStyle from "json/StdStyles.json"
import { ROLE } from "constants/userRoles"


function gerarSenhaTemporaria()
{
    const length = 8
    const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
    const charsetSpecial = "!@#$%¨&*()"
    let retVal = ""

    for (let i = 0, n = charset.length; i <= length - 1; i += 1)
    {
        retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    for (let i = 0, n = charsetSpecial.length; i <= 2 ; i += 1)
    {
        retVal += charsetSpecial.charAt(Math.floor(Math.random() * n));
    }

    return retVal;
}

export const AlterarSenhaUsuarioScreen = () =>
{
    const [senhaTemp, setSenhaTemp] = useState(undefined)
    const [showErrorAtualizarSenha, setShowErrorAtualizarSenha] = useState(false)
    const [showSucesso, setShowSucesso] = useState(false)
    const [showAlertIncompleteInput, setShowAlertIncompleteInput] = useState(false)
    const [showAlertDadosIncorretos, setShowAlertDadosIncorretos] = useState(false)
    const [matriculaWarning, setMatriculaWarning] = useState("")
    const navigate = useNavigate()
    useEffect(() => {
        if (!userLogado || !(userHasAccess(ROLE.GESTOR) || userHasAccess(ROLE.ADMIN)))
        {
            navigate(Links.SEM_PERMISSAO)
        } 
    }, [navigate])

    function validateMatricula()
    {
        let matriculaValida = true
        const matriculaInputData = document.getElementsByName("matricula")[0].value
        setMatriculaWarning("")
        if (matriculaInputData !== "" && matriculaInputData.length <= 5)
        {
            setMatriculaWarning("Mínimo de 6 caracteres")
            matriculaValida = false
        }

        return matriculaValida
    }

    const submitForm = async event =>
    {
        event.preventDefault()
        const form = event.currentTarget
        const formData = getFormData(form)
        const inputsSaoValidos = validateMatricula()
        
        if (!form.checkValidity())
        {
            setShowAlertIncompleteInput(true)
            return
        }
        if (!inputsSaoValidos)
        {
            setShowAlertDadosIncorretos(true)
            return
        }
        if (!form.checkValidity()) { return }

        try
        {
            const novaSenhaTemp = gerarSenhaTemporaria()
            setSenhaTemp(novaSenhaTemp)
            const data = 
            {
                matricula: formData.matricula,
                senha: novaSenhaTemp
            }
            const response = await AlterarSenhaParaTemporaria(data, setShowErrorAtualizarSenha)

            if (200 <= response.status && response.status <= 299)
            {
                setShowSucesso(true)
            }
            else
            {
                setShowAlertDadosIncorretos(true)
            }
        }
        catch (error)
        {
            setShowAlertDadosIncorretos(true)
        }
    }
    
    return (

        <>
            {/* <SuccessDataSaved show={showSucesso} setShow={setShowSucesso} messages={["Nova senha: " + senhaTemp]} /> */}
            <WarningInvalidInput show={showAlertDadosIncorretos} setShow={setShowAlertDadosIncorretos} messages={["Matrícula não encontrada"]} />
            <WarningIncompleteInput show={showAlertIncompleteInput} setShow={setShowAlertIncompleteInput} />
            <ErrorChamadaApiMessage apiName={"Login"} show={showErrorAtualizarSenha} setShow={setShowErrorAtualizarSenha} />

            <Form className={stdStyle.form} noValidate onSubmit={submitForm}>
                
                <TextInput Name={"matricula"} Placeholder={"000000"} Label={"Matrícula"} Warn={matriculaWarning} OnBlur={validateMatricula} Req={true} /> 
                <Button className="mt-3" type="submit">Gerar senha temporária</Button>
                {showSucesso ?
                    <div className="mt-3">
                        <p className="my-2">{"Senha alterada!"}</p>
                        <p className="my-1">{"Peça ao funcionário que use a senha abaixo para entrar na conta e"}</p>
                        <p className="my-1">{"mude-a em Minha Conta -> Dados da Conta -> Alterar senha"}</p>
                        <p className="my-1">{"A senha gerada é difícil para incentivar que seja alterada logo"}</p>
                        <p className="my-2 fw-bold">{"Nova senha: " + senhaTemp}</p>
                    </div> :
                    <></>
                }

            </Form>
        </>

    )
}